import React, { useContext, useEffect, useState } from 'react';
import { Icon, Skeleton } from '@chakra-ui/react';
import { Divider, Flex, Stack, Text } from '@chakra-ui/layout';
import { MdDevices, MdFace, MdHistory, MdOutlineRoute } from 'react-icons/md';
import { useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth/lib/authContext';
import useRecentApi from '../lib/useExperienceApi';
import PersonaProvider from '../../persona/lib/personaProvider';
import ProductProvider from '../../products/lib/productProvider';
import PersonaThumbnail from '../../persona/components/personaThumbnail';
import ProductLogo from '../../products/components/productLogo';
export default function RecentList(props) {
  const {
    insidePaddings = true,
    emptyHeight,
    maxHeight,
    onChange
  } = props;
  const {
    profile,
    hasProfile,
  } = useContext(AuthContext)
  const recentApi = useRecentApi();
  const [recentList, setRecentList] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [isInit, setIsInit] = useState(false);
  const [isReadyToFetch, setIsReadyToFecth] = useState(false);
  const navigate = useNavigate();
  const ref = useRef(null);
  async function getRecentList() {
    setIsFetching(true);
    let newRecentList;
    newRecentList = await recentApi.fetchRecents(profile.id);
    if (!newRecentList) {
      newRecentList = [];
    }
    setRecentList(newRecentList);
    if(onChange) {
      onChange(newRecentList);
    }
    setIsFetching(false);
  }
  const getHeight = () => {
    if (emptyHeight) {
      return emptyHeight
    } else {
      return "100%"
    }
  }
  useEffect(() => {
    if (isReadyToFetch && !isInit) {
      setIsInit(true);
      getRecentList();
    }
  }, [isReadyToFetch, isInit]);
  useEffect(() => {
    if (!isReadyToFetch && hasProfile) {
      setIsReadyToFecth(true);
    }
  }, [isReadyToFetch, hasProfile]);
  return (
    <>
      {( !isFetching  && recentList && recentList.length !== 0 && recentList.data !== null) &&
        <>
          <Flex
            w="100%"
            h="100%"
            flexDirection={"column"}
            border={"1px solid"}
            borderColor="divider.grey"
            mb={3}
          >
            <Flex
              alignItems='center'
              py={2}
              px={3}
              backgroundColor="white"
              borderBottom={"1px solid"}
              borderColor={"divider.grey"}
            >
              <Icon
                as={MdHistory}
                color={'fill.grey'}
                boxSize={'18px'}
                mr={2}
              />
              <Text
                variant="secondary"
                mr={3}
                fontSize="16px"
                color="text.medium.grey"
              >
                Recents
              </Text>
            </Flex>
            <Flex
              flexDirection={"column"}
              h={(!isFetching && recentList && recentList.length === 0) ? getHeight() : "auto"}
              overflow={"auto"}
              p={insidePaddings ? 3 : 0}
            >
              {isFetching && (
                <Stack p={3} spacing={2} backgroundColor={'white'}>
                  <Skeleton height='50px' />
                  <Skeleton height='50px' />
                  <Skeleton height='50px' />
                </Stack>
              )}
              <Flex
                flexDirection={"column"}
                border={(insidePaddings && recentList && recentList.length > 0) ? "1px solid" : "none"}
                borderColor="divider.grey"
                w="100%"
                h="100%"
                maxH={maxHeight}
              >
                {(!isFetching && recentList && recentList.length === 0) && (
                  <Flex
                    w="100%"
                    h="100%"
                    alignItems="center"
                    justifyContent={"center"}
                  >
                    <Text>No recents</Text>
                  </Flex>
                )}
                {(!isFetching && recentList && recentList.length > 0) && recentList.map((recent, i) => {
                  return (
                    <Flex
                      key={i}
                      flexDirection={"column"}
                    >
                      <>
                        {recent.data && (
                          <>
                            {i > 0 && <Divider />}
                            {recent.item_type === 'product' && (
                              <ProductProvider
                                originalProduct={recent.data}
                                personaId={recent.data.id}
                                needRights={false}
                                needRole={false}
                                needEditionRequest={false}
                              >
                                <Link to={`/products/${recent.data.id}`}>
                                  <Flex
                                    px={3}
                                    py={2}
                                    cursor={"pointer"}
                                    backgroundColor={"white"}
                                    _hover={{ bg: "background.grey" }}
                                    flexDirection={"column"}
                                  >
                                    <Flex gap={1} alignItems={"center"} mb={1} color="text.medium.grey">
                                      <Icon
                                        as={MdDevices}
                                        color="text.medium.grey"
                                        boxSize="16px"
                                      />
                                      <Text>Product</Text>
                                    </Flex>
                                    <Flex gap={1}>
                                      <ProductLogo size={20} />
                                      <Text>{recent.data.name}</Text>
                                    </Flex>
                                  </Flex>
                                </Link>
                              </ProductProvider>
                            )}
                            {recent.item_type === 'persona' && (
                              <PersonaProvider
                                originalPersona={recent.data}
                                personaId={recent.data.id}
                                needRights={false}
                                needRole={false}
                                needEditionRequest={false}
                              >
                                <Link to={`/persona/${recent.data.id}`}>
                                  <Flex
                                    px={3}
                                    py={2}
                                    cursor={"pointer"}
                                    backgroundColor={"white"}
                                    _hover={{ bg: "background.grey" }}
                                    flexDirection={"column"}
                                  >
                                    <Flex gap={1} alignItems={"center"} mb={1} color="text.medium.grey">
                                      <Icon
                                        as={MdFace}
                                        color="text.medium.grey"
                                        boxSize="16px"
                                      />
                                      <Text>Persona</Text>
                                    </Flex>
                                    <Flex gap={1}>
                                    <PersonaThumbnail size={20} />
                                      <Text>{recent.data.name}</Text>
                                    </Flex>
                                  </Flex>
                                </Link>
                              </PersonaProvider>
                            )}
                            {recent.item_type === 'experience' && (
                              <Link to={`/experiences/${recent.data.id}`}>
                                <Flex
                                  px={3}
                                  py={2}
                                  cursor={"pointer"}
                                  background={"white"}
                                  _hover={{ bg: "background.grey" }}
                                  flexDirection={"column"}
                                >
                                  <Flex
                                    gap={1}
                                    alignItems={"center"}
                                    mb={1}
                                    color="text.medium.grey">
                                    <Icon
                                      as={MdOutlineRoute}
                                      color="text.medium.grey"
                                      boxSize="16px"
                                    />
                                    <Text >Experience</Text>
                                  </Flex>
                                  <Text>{recent.data.objective}</Text>
                                </Flex>
                              </Link>
                            )}
                          </>
                        )}
                      </>
                    </Flex>
                  );
                })}
              </Flex>
            </Flex>
          </Flex>
        </>
      }
    </>
  );
}
